import React from "react";
import "../css/App.css";
import "../css/bootstrap.min.css";
import "../css/App.css";
import "../css/styleCustom.css";
import CustomLineItem from "./CustomLineItem";
import { toast } from "react-toastify";

class PoEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      permissions: this.props.permissions,
      vendors: [],
      selectedVendor: "0",
      vendorAddress: null,
      scrapId: null,
      shippingTerms: null,
      paymentTerms: null,
      shippingMethod: null,
      paymentStatus: null,
      shopifyFraudRisk: null,
      customerAddress: null,
      billingInformation: null,
      shopifyOrderNumber: null,
      shopifyOrderId: null,
      shopifyOrderNotes: null,
      scrapeDate: new Date().toDateString(),
      dateIssued: null,
      LineItems: [
        {
          name: null,
          sku: null,
          quantity: null,
          title: null,
          price: null,
          supplier_cost: null,
          properties: [
            {
              name: null,
              value: null,
              caption: null,
              supplier_cost: null,
              customer_price: null,
            },
          ],
        },
      ],
      formData: [
        {
          id: 1,
          pProperty: "",
          pAttribute: "",
          pCaption: null,
          pSupplier_cost: null,
          pCustomer_price: null,
        },
      ],
      lineId: [],
      form: {},
      totalPrice: null,
      totalDiscount: null,
      shipingAddress: null,
      shipping_code: null,
      shipingMethod: null,
      paymentTerm: null,
      totalOutstanding: null,
      formCount: 0,
      formCount1: 0,
      vendorData: "",
      result1: [],
      shipment_status:false,
      factory_photos_sent: false,
      consolidation_status: false,
      factory_photo_approval: false,
      shipment_transit_status: false,
      tracking_number: "",      
      paypal_protection_eligibility: "",      
      avs_result_code: "",
      avs_result_definition: "",     
      requested_delivery_date: "",
      signature: "",      
      //vendor: "",     
      list_item_subtotal: "",      
      shipping_handling: "",
      profitability_score: "",
      extra_shipping: "",      
      wire_transfer_fee: "",
      price_verified: false,
      exchange_rate_fee: "",
      other_adjustments: "",
      adjustment_notes: "",
      po_total: "",
      less_payments: "",      
      canadian_exchange_rate: "",      
    };
    this.saveScrapData = this.saveScrapData.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (e, key) => {
    console.log(e.target.name, e.target.value);
    this.setState((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  handleChange2 = (e, index) => {
    const LineItems = [...this.state.LineItems];
    LineItems[index][e.target.name] = e.target.value;
    this.setState({ LineItems });
  };

  handleChangeForProperty = (e, lineItemIndex, propertyIdenx) => {
    const LineItems = [...this.state.LineItems];
    LineItems[lineItemIndex].properties[propertyIdenx][e.target.name] =
      e.target.value;
    this.setState({ LineItems });
  };

  handleGenerate = () => {
    this.props.history.push({
      pathname: `/template`,
      data: this.state.result1,
      vendor: this.state.vendors,
      shippingTerms: this.state.shippingTerms,
      paymentTerm: this.state.paymentTerms,
      shippingMethod: this.state.shippingMethod,
      vendorAddress: this.state.vendorAddress,
      selectedVendorName: this.state.selectedVendor,
    });    
  };

  navigateToChild = () => { 
    let r={result2: this.state.result1,
      vendors2: this.state.vendors,        
      shippingTerms: this.state.shippingTerms,
      paymentTerm: this.state.paymentTerms,
      shippingMethod: this.state.shippingMethod,
      vendorAddress: this.state.vendorAddress, 
      selectedVendorName: this.state.selectedVendor,}
      
    const newTab = window.open('/templates');
    
      newTab.myObj = r

      
  };

  handleAddItem = () => {
    this.setState((prevState) => ({
      formCount: prevState.formCount + 1,
    }));
  };

  addEmptyForm = (id) => {
    console.log(this.state.LineItems);
    this.state.LineItems?.map((x) => {
      console.log(x.properties);
    });
    // const { forms } = this.state;
    const formData = [...this.state.formData];
    // Find the index of the form data with the specified ID
    const dataExists = this.state.LineItems.find((x) => x.id === id);
    const dataToPush = {
      name: "",
      value: "",
      
    };
    dataExists.properties.push(dataToPush);
    this.setState({ formData });
  };

  componentDidMount = async () => {
    await this.loadVendor();
    const storedOrderDetail = localStorage.getItem('orderDetail');
    const storedOrderRisk = localStorage.getItem('orderRisk');  
  // Parse JSON data if it exists
    const orderDetail = storedOrderDetail ? JSON.parse(storedOrderDetail) : null;
    const orderRisk = storedOrderRisk || 'DefaultRisk';
    console.log(orderDetail)
    console.log(orderRisk)
    this.setState({ result1: orderDetail });   
    this.setState({ shopifyFraudRisk: orderRisk });
    this.setState({
      customerAddress:
        orderDetail.shipping_address.first_name +
        " " +
        orderDetail.shipping_address.last_name +
        "\n" +
        orderDetail.shipping_address.address1 +
        "\n" +
        orderDetail.shipping_address.address2 +
        "\n" +
        orderDetail.shipping_address.city +
        " " +
        orderDetail.shipping_address.province_code +
        " " +
        orderDetail.shipping_address.zip +
        "\n" +
        orderDetail.shipping_address.country,
    });
    this.setState({
      billingInformation:
        orderDetail.billing_address.first_name +
        " " +
        orderDetail.billing_address.last_name +
        "\n" +
        orderDetail.billing_address.address1 +
        "\n" +
        orderDetail.billing_address.address2 +
        "\n" +
        orderDetail.billing_address.city +
        " " +
        orderDetail.billing_address.province_code +
        " " +
        orderDetail.billing_address.zip +
        "\n" +
        orderDetail.billing_address.country,
    });
    this.setState({ shopifyOrderNumber: orderDetail.name });
    this.setState({ shopifyOrderId: orderDetail.id });
    this.setState({ shopifyOrderNotes: orderDetail.note });
    this.setState({ LineItems: orderDetail.line_items });

    // this.setState({ dateIssued: orderDetail.processed_at });

    this.setState({
      dateIssued: new Date(orderDetail.processed_at)
        .toLocaleString("en-GB", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })
        .replace(/\//g, "-"),
    });

    this.setState({ paymentTerm: orderDetail.payment_terms });
    this.setState({
      shipingAddress:
        orderDetail.shipping_address.address1 +
        " " +
        orderDetail.shipping_address.address2 +
        " " +
        orderDetail.shipping_address.city +
        " \n" +
        orderDetail.shipping_address.country +
        " " +
        orderDetail.shipping_address.country_code,
    });

    this.setState({ shipping_code: orderDetail.shipping_address.zip });

    this.setState({ totalPrice: orderDetail.total_price });
    this.setState({ totalDiscount: orderDetail.total_discounts });
    this.setState({ totalOutstanding: orderDetail.total_outstanding });

    // scrap id

    this.setState({ scrapId: orderDetail.id });

    //this.setState({subTotalItem:orderDetail.current_subtotal_price})

    this.setState({ shipingMethod: orderDetail.processing_method });

    this.setState({paymentStatus:orderDetail.financial_status})

    this.setState({ lineId: orderDetail.line_items?.map((item) => item.id) });
  };

  saveScrapData = async (e) => {
    e.preventDefault();

    
    var dataToPost = new FormData();

    dataToPost.append("order_id", this.state.scrapId);

    dataToPost.append("shipment_status", this.state.shipment_status);
    dataToPost.append("factory_photos_sent", this.state.factory_photos_sent);
    dataToPost.append("consolidation_status", this.state.consolidation_status);
    dataToPost.append(
      "factory_photo_approval",
      this.state.factory_photo_approval
    );
    dataToPost.append(
      "shipment_transit_status",
      this.state.shipment_transit_status
    );
    dataToPost.append("tracking_number", this.state.tracking_number);
    dataToPost.append("payment_status", this.state.paymentStatus);
    dataToPost.append(
      "paypal_protection_eligibility",
      this.state.paypal_protection_eligibility
    );
    dataToPost.append("shopify_fraud_risk", this.state.shopifyFraudRisk);
    dataToPost.append("avs_result_code", this.state.avs_result_code);
    dataToPost.append(
      "avs_result_definition",
      this.state.avs_result_definition
    );
    dataToPost.append("customer_address", this.state.customerAddress);
    dataToPost.append("billing_information", this.state.billingInformation);
    dataToPost.append("shopify_order_number", this.state.shopifyOrderNumber);
    dataToPost.append("shopify_order_id", this.state.shopifyOrderId);
    dataToPost.append("shopify_order_notes", this.state.shopifyOrderNotes);
    dataToPost.append("scrape_date", this.state.scrapeDate);
    dataToPost.append("date_issued", this.state.dateIssued);
    dataToPost.append(
      "requested_delivery_date",
      this.state.requested_delivery_date
    );
    dataToPost.append("signature", this.state.signature);
    dataToPost.append("shipping_code", this.state.shipping_code);
    dataToPost.append("ship_to_address", this.state.shipingAddress);
    dataToPost.append("vendor", this.state.selectedVendor);
    dataToPost.append("vendor_address", this.state.vendorAddress);
    dataToPost.append("shipping_terms", this.state.shippingTerms);
    dataToPost.append("payment_terms", this.state.paymentTerms);
    dataToPost.append("shipping_method", this.state.shipingMethod);
    dataToPost.append("list_item_subtotal", this.state.list_item_subtotal);
    dataToPost.append("customer_price_total", this.state.totalPrice);
    dataToPost.append("shipping_handling", this.state.shipping_handling);
    dataToPost.append("profitability_score", this.state.profitability_score);
    dataToPost.append("extra_shipping", this.state.extra_shipping);
    dataToPost.append("discount", this.state.totalDiscount);
    dataToPost.append("wire_transfer_fee", this.state.wire_transfer_fee);
    dataToPost.append("price_verified", this.state.price_verified);
    dataToPost.append("exchange_rate_fee", this.state.exchange_rate_fee);
    dataToPost.append("other_adjustments", this.state.other_adjustments);
    dataToPost.append("adjustment_notes", this.state.adjustment_notes);
    dataToPost.append("po_total", this.state.po_total);
    dataToPost.append("less_payments", this.state.less_payments);
    dataToPost.append("outstanding_amount", this.state.totalOutstanding);
    dataToPost.append(
      "canadian_exchange_rate",
      this.state.canadian_exchange_rate
    );
    // const dataExists = this.state.LineItems.find((x) => x.id === id);
    dataToPost.append("line_items", JSON.stringify(this.state.LineItems));

    console.log(this.state.LineItems);

   

    var requestOptions = {
      method: "POST",
      body: dataToPost,
      // redirect: 'follow'
    };
    console.log("data", requestOptions);
    await fetch(
      "https://dashboard.realsexdoll.info/php/poeditor/savescrapedata.php",
      requestOptions
    )
      .then((response) =>
        // console.log("API Response===>>>>:", response)
        response.text()
      )
      .then((data) => {
        console.log("API Response:", data);
        toast.success("saved data successfully !! ");
      })
      .catch((error) => console.log("error", error));
  };

  loadVendor = async () => {
    var requestOptions = {
      method: "GET",
    };
    await fetch(
      "https://dashboard.realsexdoll.info/php/vendors/vendors.php",
      requestOptions
    )
      .then((response) => response.json())
      .then((orderDetail) => {
        this.state.vendors = orderDetail;
      })
      .catch((error) => console.log("error", error));
  };

  handleVendorChange = async (event) => {
    const selectedVendor = this.state.vendors.find(
      (data) => data.id === event.target.value
    );
    // console.log(selectedVendor)
    this.setState({ selectedVendor: selectedVendor.vendorName });
    if (event.target.value > 0)
      var requestOptions = {
        method: "GET",
      };
    await fetch(
      `https://dashboard.realsexdoll.info/php/vendors/vendor.php?vendorId=${event.target.value}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((orderDetail) => {
        this.setState({ vendorAddress: orderDetail[0].factoryAddress });
        this.setState({ shippingTerms: orderDetail[0].shippingTerms });
        this.setState({ paymentTerms: orderDetail[0].paymentTerms });
        this.setState({ shippingMethod: orderDetail[0].shippingMethod });
      })
      .catch((error) => console.log("error", error));
  };

  render() {
    const vendor = this.state.vendors;
    const { LineItems } = this.state;
    const { totalPrice } = this.state;
    const { totalDiscount } = this.state;
    const { totalOutstanding } = this.state;
    const { shipingAddress } = this.state;
    const { shipping_code } = this.state;
    const { dateIssued } = this.state;
    const { formCount } = this.state;
    // const { formCount1 } = this.state;
    // const { lineId } = this.state;   
    // const { scrapId } = this.state;
    return (
      <div className="cookie-Scrapper bg-light">
        <form >
          <div className="OrderListScrap-container p-3">
            <div className="OrderListScrap-wrapper">
              <div className="container">
                <div className="viewscrapdata-box">
                  <div className="text-end mb-5">
                    <button type="submit" className="btn-base btn-sm" disabled>
                      View Raw Scrap Data
                    </button>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-4">
                      <div className="form-check form-check-inline mb-5">
                        <input
                          className="form-check-input"
                          value=""
                          type="checkbox"
                          onChange={this.handleChange}
                          name="shipment_status"
                        />
                        <label className="form-check-label">
                          See Shipment - In Progress
                        </label>
                      </div>
                    </div>

                    <div className="col-12 col-sm-4">
                      <div className="form-check form-check-inline  mb-5">
                        <input
                          className="form-check-input"
                          value=""
                          type="checkbox"
                          onChange={this.handleChange}
                          name="factory_photos_sent"
                        />
                        <label className="form-check-label">
                          Factory Photos Sent to Customer
                        </label>
                      </div>
                    </div>

                    <div className="col-12 col-sm-4">
                      <div className="form-check form-check-inline  mb-5">
                        <input
                          className="form-check-input"
                          value=""
                          type="checkbox"
                          onChange={this.handleChange}
                          name="consolidation_status"
                        />
                        <label className="form-check-label">
                          See Shipment - Ready for Consolidation
                        </label>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="form-check form-check-inline  mb-3">
                        <input
                          className="form-check-input"
                          value=""
                          type="checkbox"
                          onChange={this.handleChange}
                          name="factory_photo_approval"
                        />
                        <label className="form-check-label">
                          Factory Photo OK'ed with Supplier
                        </label>
                      </div>
                    </div>

                    <div className="col-12 col-sm-4">
                      <div className="form-check form-check-inline  mb-3">
                        <input
                          className="form-check-input"
                          value=""
                          type="checkbox"
                          onChange={this.handleChange}
                          name="shipment_transit_status"
                        />
                        <label className="form-check-label">
                          Sea Shipment - In Transit
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="viewscrapdata-box">
                  <div className="row">
                    <div className="col-12 col-lg-4">
                      <div className="row">
                        <label
                          for="inputtext"
                          className="col-sm-4 col-form-label"
                        >
                          Tracking Number
                        </label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="form-control"
                            id="inputtext"
                            onChange={this.handleChange}
                            name="tracking_number"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="viewscrapdata-box">
                  <h3>Fraud Analysis</h3>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Payment Status
                        </label>
                        <div class="col-12 col-lg-7">
                          <input
                            type="text"
                            className="form-control"
                            id="inputtext"
                            value={this.state.paymentStatus}
                            onChange={this.handleChange}
                            name="paymentStatus"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Shopify Fraud Risk
                        </label>
                        <div className="col-12 col-lg-7">
                          <input
                            type="text"
                            className="form-control"
                            id="inputtext"
                            value={this.state.shopifyFraudRisk}
                            onChange={this.handleChange}
                            name="shopifyFraudRisk"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Paypal Protection Eligibility
                        </label>
                        <div className="col-12 col-lg-7">
                          <input
                            type="text"
                            className="form-control"
                            id="inputtext"
                            onChange={this.handleChange}
                            name="paypal_protection_eligibility"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          AVS Result Code
                        </label>
                        <div className="col-12 col-lg-7">
                          <input
                            type="text"
                            className="form-control"
                            id="inputtext"
                            onChange={this.handleChange}
                            name="avs_result_code"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          class="col-12 col-lg-4 col-form-label"
                        >
                          AVS Result Definition
                        </label>
                        <div className="col-12 col-lg-7">
                          <textarea
                            type="text"
                            className="form-control"
                            id="inputtext"
                            onChange={this.handleChange}
                            name="avs_result_definition"
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Customer Address
                        </label>
                        <div className="col-12 col-lg-7">
                          <textarea
                            type="text"
                            className="form-control"
                            id="inputtext"
                            value={this.state.customerAddress}
                            onChange={this.handleChange}
                            name="customerAddress"
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          class="col-12 col-lg-4 col-form-label"
                        >
                          Billing Information
                        </label>
                        <div class="col-12 col-lg-7">
                          <textarea
                            type="text"
                            className="form-control"
                            id="inputtext"
                            value={this.state.billingInformation}
                            onChange={this.handleChange}
                            name="billingInformation"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="viewscrapdata-box">
                  <h3>Shopify Information</h3>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Shopify Order Number
                        </label>
                        <div className="col-12 col-lg-7">
                          <input
                            type="text"
                            className="form-control"
                            id="inputtext"
                            value={this.state.shopifyOrderNumber}
                            onChange={this.handleChange}
                            name="shopifyOrderNumber"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Shopify Order ID
                        </label>
                        <div className="col-12 col-lg-7">
                          <input
                            type="text"
                            className="form-control"
                            id="inputtext"
                            value={this.state.shopifyOrderId}
                            onChange={this.handleChange}
                            name="shopifyOrderId"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Shopify Order Notes
                        </label>
                        <div className="col-12 col-lg-7">
                          <textarea
                            type="text"
                            className="form-control"
                            id="inputtext"
                            value={this.state.shopifyOrderNotes}
                            onChange={this.handleChange}
                            name="shopifyOrderNotes"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-12">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Scrape Date
                        </label>
                        <div className="col-12 col-lg-7">
                          <input
                            type="text"
                            className="form-control"
                            id="inputtext"
                            value={this.state.scrapeDate}
                            onChange={this.handleChange}
                            name="scrapeDate"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="viewscrapdata-box">
                  <h3>PO Document</h3>

                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Date Issued
                        </label>
                        <div className="col-12 col-lg-7">
                          <input
                            type="text"
                            className="form-control"
                            id="inputtext"
                            value={dateIssued}
                            onChange={this.handleChange}
                            name="dateIssued"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Requested Delivery Date
                        </label>
                        <div className="col-12 col-lg-7">
                          <input
                            type="text"
                            className="form-control"
                            id="inputtext"
                            // value={"As Soon As Possible"}
                            onChange={this.handleChange}
                            name="requested_delivery_date"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Signature
                        </label>
                        <div className="col-12 col-lg-7">
                          <input
                            type="text"
                            className="form-control"
                            id="inputtext"
                            onChange={this.handleChange}
                            name="signature"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Shipping Code
                        </label>
                        <div class="col-12 col-lg-7">
                          <input
                            type="text"
                            className="form-control"
                            id="inputtext"
                            value={shipping_code}
                            onChange={this.handleChange}
                            name="shipping_code"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Ship To Address
                        </label>
                        <div className="col-12 col-lg-7">
                          <textarea
                            type="text"
                            class="form-control"
                            id="inputtext"
                            value={shipingAddress}
                            onChange={this.handleChange}
                            name="shipingAddress"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Vendor
                        </label>
                        <div className="col-12 col-lg-7">
                        
                          <select
                          
                            id="vendorDropdown"
                            className="form-select"
                            //value={this.state.selectedVendor}
                            onChange={this.handleVendorChange}
                            name="selectedVendor"
                            
                          >

                            <option value="0">
                              Select Vendor
                            </option>
                            {vendor &&
                              vendor?.map((data) => (
                                <option key={data.id} value={data.id}>
                                  {data.vendorName}
                                </option>
                              ))}

                            {/* add input box */}
                            <input type="text" onChange={this.handleChange}/>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Vendor Address
                        </label>
                        <div className="col-12 col-lg-7">
                          <textarea
                            type="text"
                            class="form-control"
                            id="inputtext"
                            value={this.state.vendorAddress}
                            onChange={this.handleChange}
                            name="vendorAddress"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Shipping Terms
                        </label>
                        <div className="col-12 col-lg-7">
                          <input
                            type="text"
                            className="form-control"
                            id="inputtext"
                            value={this.state.shippingTerms}
                            onChange={this.handleChange}
                            name="shippingTerms"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Payment Terms
                        </label>
                        <div className="col-12 col-lg-7">
                          <input
                            type="text"
                            className="form-control"
                            id="inputtext"
                            value={this.state.paymentTerms}
                            onChange={this.handleChange}
                            name="paymentTerms"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-4 col-form-label"
                        >
                          Shipping Method
                        </label>
                        <div className="col-12 col-lg-7">
                          <textarea
                            type="text"
                            className="form-control"
                            id="inputtext"
                            value={this.state.shippingMethod}
                            onChange={this.handleChange}
                            name="shippingMethod"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* line items */}

                <div className="list-item-section">
                  <div className="mt-4">
                    <h3>Line Items</h3>
                    {LineItems?.map((item, key) => (
                      <div>
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="card border border-1 shadow-sm p-3">
                              <div className="row">
                                <div className="col-md-2">
                                  <div className="img-wrapper">
                                    <img src="" alt="" className="img-fluid" />
                                  </div>
                                </div>
                                <div className="col-md-8">
                                  <div className="mb-3 row">
                                    <label
                                      for="inputtext"
                                      className="col-12 col-lg-2 col-form-label"
                                    >
                                      Name
                                    </label>
                                    <div class="col-12 col-lg-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="inputtext"
                                        value={item.name}
                                        onChange={(e) =>
                                          this.handleChange2(e, key)
                                        }
                                        name="name"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label
                                      for="inputtext"
                                      className="col-12 col-lg-2 col-form-label"
                                    >
                                      SKU
                                    </label>
                                    <div className="col-12 col-lg-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="inputtext"
                                        value={item.sku}
                                        onChange={(e) =>
                                          this.handleChange2(e, key)
                                        }
                                        name="sku"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label
                                      for="inputtext"
                                      className="col-12 col-lg-2 col-form-label"
                                    >
                                      Quantity
                                    </label>
                                    <div className="col-12 col-lg-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="inputtext"
                                        value={item.quantity}
                                        onChange={(e) =>
                                          this.handleChange2(e, key)
                                        }
                                        name="quantity"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-2">
                                  <div className="text-center">
                                    <button
                                      type="button"
                                      className="btn-base btn-sm w-100"
                                      disabled
                                    >
                                      Button
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="row mt-4">
                                <div className="col-md-6">
                                  <div className="mb-3 row">
                                    <label
                                      for="inputtext"
                                      className="col-12 col-lg-2 col-form-label"
                                    >
                                      Caption
                                    </label>
                                    <div className="col-12 col-lg-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="inputtext"
                                        value={item.title}
                                        onChange={(e) =>
                                          this.handleChange2(e, key)
                                        }
                                        name="title"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3 row justify-content-end">
                                    <label
                                      for="inputtext"
                                      className="col-12 col-lg-3 col-form-label"
                                    >
                                      Supplier Cost
                                    </label>
                                    <div className="col-12 col-lg-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="inputtext"
                                        onChange={(e) =>
                                          this.handleChange2(e, key)
                                        }
                                        name="supplier_cost"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row justify-content-end">
                                    <label
                                      for="inputtext"
                                      className="col-12 col-lg-3 col-form-label"
                                    >
                                      Customer Price
                                    </label>
                                    <div className="col-12 col-lg-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="inputtext"
                                        value={item.price}
                                        onChange={(e) =>
                                          this.handleChange2(e, key)
                                        }
                                        name="price"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="listItems-boxes">
                          {/* add custom property  */}

                          {item.properties?.map((p, propertyIdenx) => (
                            <div className="container">
                              <div className="row mt-2">
                                <div className="col-lg-12">
                                  <div className="card border border-1 shadow-sm p-3">
                                    <div className="row">
                                      <div className="col-md-2">
                                        <div className="img-wrapper">
                                          <img
                                            src=""
                                            alt=""
                                            className="img-fluid"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-7">
                                        <div className="mb-3 row">
                                          <label
                                            for="inputtext"
                                            className="col-12 col-lg-2 col-form-label"
                                          >
                                            Property
                                          </label>
                                          <div className="col-12 col-lg-6">
                                            <input
                                              type="text"
                                              className="form-control"
                                              id="inputtext"
                                              value={p.name}
                                              onChange={(e) =>
                                                this.handleChangeForProperty(
                                                  e,
                                                  key,
                                                  propertyIdenx
                                                )
                                              }
                                              name="name"
                                            />
                                          </div>
                                        </div>
                                        <div className="mb-3 row">
                                          <label
                                            for="inputtext"
                                            className="col-12 col-lg-2 col-form-label"
                                          >
                                            Attribute
                                          </label>
                                          <div className="col-12 col-lg-6">
                                            <input
                                              type="text"
                                              className="form-control"
                                              id="inputtext"
                                              value={p.value}
                                              onChange={(e) =>
                                                this.handleChangeForProperty(
                                                  e,
                                                  key,
                                                  propertyIdenx
                                                )
                                              }

                                              name="value"
                                            />
                                          </div>
                                        </div>
                                        <div className="mb-3 row">
                                          <label
                                            for="inputtext"
                                            className="col-12 col-lg-2 col-form-label"
                                          >
                                            Caption
                                          </label>
                                          <div className="col-12 col-lg-6">
                                            <input
                                              type="text"
                                              className="form-control"
                                              id="inputtext"
                                              onChange={(e) =>
                                                this.handleChangeForProperty(
                                                  e,
                                                  key,
                                                  propertyIdenx
                                                )
                                              }
                                              name="caption"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <div className="row">
                                          <div className="col-md-12">
                                            <div className="text-center pb-4">
                                              <button
                                                type="button"
                                                className="btn-base btn-sm w-100"
                                                disabled
                                              >
                                                Button
                                              </button>
                                            </div>
                                          </div>
                                          <div className="col-md-12">
                                            <div className="mb-3 row ">
                                              <label
                                                for="inputtext"
                                                className="col-12 col-lg-4 col-form-label"
                                              >
                                                Supplier Cost
                                              </label>
                                              <div className="col-12 col-lg-8">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="inputtext"
                                                  onChange={(e) =>
                                                    this.handleChangeForProperty(
                                                      e,
                                                      key,
                                                      propertyIdenx
                                                    )
                                                  }
                                                  name="supplier_cost"
                                                />
                                              </div>
                                            </div>
                                            <div className="mb-3 row ">
                                              <label
                                                for="inputtext"
                                                className="col-12 col-lg-4 col-form-label"
                                              >
                                                Customer Price
                                              </label>
                                              <div className="col-12 col-lg-8">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="inputtext"
                                                  onChange={(e) =>
                                                    this.handleChangeForProperty(
                                                      e,
                                                      key,
                                                      propertyIdenx
                                                    )
                                                  }
                                                  name="customer_price"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="mt-4">
                          <div className="d-flex gap-4 justify-content-center">
                            <button
                              className="btn-base btn-sm"
                              type="button"
                              disabled
                            >
                              Add Property Bottom
                            </button>
                            <button
                              className="btn-base btn-sm"
                              type="button"
                              onClick={() => this.addEmptyForm(item.id)}
                            >
                              Add Property Top
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Render FormComponent based on formCount */}
              {Array.from({ length: formCount })?.map((_, index) => (
                <CustomLineItem />
              ))}
              <div className="text-end mt-3 mb-5">
                <button
                  type="button"
                  className="btn-sm btn-outline-additem"
                  onClick={this.handleAddItem}
                  disabled
                >
                  Add List Item
                </button>
              </div>

              <div className="poNotes-section viewscrapdata-box">
                <div className="container">
                  <div className="mb-3 row">
                    <label
                      for="inputtext"
                      className="col-12 col-lg-2 col-form-label"
                    >
                      Internal Notes
                    </label>
                    <div className="col-12 col-lg-10">
                      <textarea
                        type="text"
                        className="form-control"
                        id="inputtext"
                      ></textarea>
                      <label className="text-center text-muted d-block my-1">
                        Appears on General Report and NOT Purchase Order
                      </label>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label
                      for="inputtext"
                      className="col-12 col-lg-2 col-form-label"
                    >
                      PO Notes
                    </label>
                    <div className="col-12 col-lg-10">
                      <textarea
                        type="text"
                        className="form-control"
                        id="inputtext"
                      ></textarea>
                      <label className="d-block text-muted text-center my-1">
                        Appears on actual Purchase Order in the "Notes" field
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="chargesTotal-section viewscrapdata-box">
                <h3>Charges & Totals</h3>
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputPassword"
                          className="col-12 col-md-3 col-form-label"
                        >
                          List Item Subtotal
                        </label>
                        <div className="col-12 col-md-9">
                          <input
                            type="text"
                            className="form-control"
                            id="inputPassword"
                            onChange={this.handleChange}
                            name="list_item_subtotal"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputPassword"
                          className="col-12 col-md-3 col-form-label"
                        >
                          Customer Price Total
                        </label>
                        <div className="col-12 col-md-9">
                          <input
                            type="text"
                            className="form-control"
                            id="inputPassword"
                            value={totalPrice}
                            onChange={this.handleChange}
                            name="totalPrice"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputPassword"
                          className="col-12 col-md-3 col-form-label"
                        >
                          Shipping / Handling
                        </label>
                        <div className="col-12 col-md-9">
                          <input
                            type="text"
                            className="form-control"
                            id="inputPassword"
                            onChange={this.handleChange}
                            name="shipping_handling"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputPassword"
                          className="col-12 col-md-3 col-form-label"
                        >
                          Profitability Score
                        </label>
                        <div className="col-12 col-md-9">
                          <input
                            type="text"
                            className="form-control"
                            id="inputPassword"
                            onChange={this.handleChange}
                            name="profitability_score"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-12">
                      <div className="mb-3 row">
                        <label
                          for="inputPassword"
                          className="col-12 col-md-3 col-form-label"
                        >
                          Extra Shipping
                        </label>
                        <div className="col-12 col-md-9">
                          <input
                            type="text"
                            className="form-control"
                            id="inputPassword"
                            onChange={this.handleChange}
                            name="extra_shipping"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-12">
                      <div className="mb-3 row">
                        <label
                          for="inputPassword"
                          className="col-12 col-md-3 col-form-label"
                        >
                          Discount
                        </label>
                        <div className="col-12 col-md-9">
                          <input
                            type="text"
                            className="form-control"
                            id="inputPassword"
                            value={totalDiscount}
                            onChange={this.handleChange}
                            name="totalDiscount"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <label
                          for="inputPassword"
                          className="col-12 col-md-3 col-form-label"
                        >
                          Wire Transfer Fee
                        </label>
                        <div className="col-12 col-md-9">
                          <input
                            type="text"
                            className="form-control"
                            id="inputPassword"
                            onChange={this.handleChange}
                            name="wire_transfer_fee"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="mb-3 row">
                        <div className=" col-1">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                            onChange={this.handleChange}
                            name="price_verified"
                          />
                        </div>
                        <label
                          className="form-check-label col-11"
                          for="flexCheckDefault"
                        >
                          Price is Verified
                        </label>
                      </div>
                    </div>
                    <div className="col-12 col-md-12">
                      <div className="mb-3 row">
                        <label
                          for="inputPassword"
                          className="col-12 col-md-3 col-form-label"
                        >
                          Exchange rate fee
                        </label>
                        <div className="col-12 col-md-9">
                          <input
                            type="text"
                            className="form-control"
                            id="inputPassword"
                            onChange={this.handleChange}
                            name="exchange_rate_fee"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-12">
                      <div className="mb-3 row">
                        <label
                          for="inputPassword"
                          className="col-12 col-md-3 col-form-label"
                        >
                          Other Adjustments
                        </label>
                        <div className="col-12 col-md-9">
                          <input
                            type="text"
                            className="form-control"
                            id="inputPassword"
                            onChange={this.handleChange}
                            name="other_adjustments"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-12">
                      <div className="mb-3 row">
                        <label
                          for="inputPassword"
                          className="col-12 col-md-3 col-form-label"
                        >
                          Adjustment Notes
                        </label>
                        <div className="col-12 col-md-9">
                          <textarea
                            type="text"
                            className="form-control"
                            id="inputtext"
                            onChange={this.handleChange}
                            name="adjustment_notes"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-12">
                      <div className="container">
                        <div className="mb-3 row justify-content-center">
                          <label
                            for="inputtext"
                            className="col-12 col-md-2 col-form-label"
                          >
                            PO Total
                          </label>
                          <div className="col-12 col-md-4">
                            <input
                              type="text"
                              className="form-control"
                              id="inputtext"
                              onChange={this.handleChange}
                              name="po_total"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-12">
                      <div className="container">
                        <div className="mb-3 row justify-content-center">
                          <label
                            for="inputtext"
                            className="col-12 col-md-2 col-form-label"
                          >
                            LESS:Payments
                          </label>
                          <div className="col-12 col-md-4">
                            <input
                              type="text"
                              className="form-control"
                              id="inputtext"
                              onChange={this.handleChange}
                              name="less_payments"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-12">
                      <div className="container">
                        <div class="mb-3 row justify-content-center">
                          <label
                            for="inputtext"
                            className="col-12 col-md-2 col-form-label"
                          >
                            Outstanding
                          </label>
                          <div className="col-12 col-md-4">
                            <input
                              type="text"
                              className="form-control"
                              id="inputtext"
                              value={totalOutstanding}
                              onChange={this.handleChange}
                              name="totalOutstanding"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-12">
                      <div className="container text-center">
                        <button className="btn-base btn-sm">
                          Re-Calculate
                        </button>
                      </div>
                    </div>
                    <div className="col-12 col-md-12">
                      <div className="container">
                        <div className="my-4 row justify-content-center">
                          <label
                            for="inputtext"
                            className="col-12 col-md-3 col-form-label"
                          >
                            Canadian Exchange Rate (this PO only)
                          </label>
                          <div className="col-12 col-md-3">
                            <input
                              type="text"
                              className="form-control"
                              id="inputtext"
                              onChange={this.handleChange}
                              name="canadian_exchange_rate"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-4 mb-4">
                <h3>Payments</h3>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="card border border-1 shadow-sm ">
                        <div className="modal-header border border-0">
                          <h5 className="modal-title" id="exampleModalLabel">
                            New Payment
                          </h5>
                          <button
                            type="button"
                            className="btn-base"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          >
                            Add to Payments
                          </button>
                        </div>
                        <div className="modal-body">
                          <div className="row ">
                            <div className="col-12 col-md-6">
                              <div className="mb-3 row justify-content-center">
                                <label
                                  for="inputPassword"
                                  className="col-12 col-md-4 col-form-label"
                                >
                                  Amount
                                </label>
                                <div className="col-12 col-md-6">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="inputPassword"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-md-6">
                              <div className="mb-3 row justify-content-center">
                                <label
                                  for="inputPassword"
                                  className="col-12 col-md-4 col-form-label"
                                >
                                  Payment Method
                                </label>
                                <div className="col-12 col-md-6">
                                  <select
                                    className="form-select"
                                    aria-label="Default select example"
                                  >
                                    <option selected>
                                      Open this select menu
                                    </option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-md-12">
                              <div className="mb-3 row justify-content-center">
                                <label
                                  for="inputPassword"
                                  className="col-12 col-md-3 col-form-label"
                                >
                                  Notes
                                </label>
                                <div className="col-12 col-md-8">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="inputPassword"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="py-5">
                <div className="container-fluid">
                  <div className="row align-items-center">
                    <div className="col-12 col-lg-3">
                      <div className="row">
                        <div className="col-lg-6">
                          <button
                            type="submit"
                            className="btn-base btn-sm w-100"
                          >
                            Void Entire PO
                          </button>
                        </div>
                        <div className="col-lg-6">
                          <button
                            type="submit"
                            className="btn-base btn-sm w-100"
                          >
                            Unvoid
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6">
                      <div className="row">
                        <label
                          for="inputtext"
                          className="col-12 col-lg-3 col-form-label"
                        >
                          Override
                        </label>
                        <div className="col-12 col-lg-8">
                          <input
                            type="text"
                            className="form-control"
                            id="inputtext"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-lg-3">
                      <div className="row">
                        <div className="col-lg-6">
                          <button
                           
                            className="btn-base btn-sm w-100"
                            onClick={this.saveScrapData}
                          >
                            Save
                          </button>
                        </div>
                        <div className="col-lg-6">
                          <button
                            className="btn-base btn-sm w-100"
                            onClick={() => this.navigateToChild()}
                          >
                            Generate
                          </button>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default PoEditor;
